import { observer } from 'mobx-react-lite'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import React from 'react'
import Stack from '@mui/material/Stack'
import { themeConfig } from '@gap/shared/theme'

export interface AuthCardWrapperProps {
   title: string
   subtitle?: string
   children: React.ReactNode
   maxWidth?: string
}

export default observer(function AuthCardWrapper(props: React.PropsWithChildren<AuthCardWrapperProps>) {

   return <Stack sx={{ padding: 1, '.MuiButton-sizeLarge': { fontSize: '0.9375rem' } }}>
      <Card variant="outlined" sx={{
         width: '100%',
         maxWidth: props.maxWidth || '564px',
         marginX: 'auto',
         borderRadius: '16px',
         borderColor: themeConfig.primary[200],
      }}>
         <CardContent sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            px: 3,
            pt: 2,
         }}>
            <Stack sx={{ gap: 1 }}>
               <Typography variant="h4">
                  {props.title}
               </Typography>
               {props.subtitle && <Typography>{props.subtitle}</Typography>}
            </Stack>
            <Stack>{props.children}</Stack>
         </CardContent>
      </Card>
   </Stack>
})
